// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AddToCartController from "./add_to_cart_controller"
application.register("add-to-cart", AddToCartController)

import Account__ApplePayBalanceDueController from "./account/apple_pay_balance_due_controller"
application.register("account--apple-pay-balance-due", Account__ApplePayBalanceDueController)

import Admin__ChangeShippingRateController from "./admin/change_shipping_rate_controller"
application.register("admin--change-shipping-rate", Admin__ChangeShippingRateController)

import Checkout__CreditCardController from "./checkout/credit_card_controller"
application.register("checkout--credit-card", Checkout__CreditCardController)

import Checkout__CreditCardIconController from "./checkout/credit_card_icon_controller"
application.register("checkout--credit-card-icon", Checkout__CreditCardIconController)

import Checkout__PaymentController from "./checkout/payment_controller"
application.register("checkout--payment", Checkout__PaymentController)

import CookieConsentController from "./cookie_consent_controller"
application.register("cookie-consent", CookieConsentController)

import ClickController from "./click_controller"
application.register("click", ClickController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import EmailcheckController from "./emailcheck_controller"
application.register("emailcheck", EmailcheckController)

import Fields__PhoneController from "./fields/phone_controller"
application.register("fields--phone", Fields__PhoneController)

import Fields__ValidationController from "./fields/validation_controller"
application.register("fields--validation", Fields__ValidationController)

import FocusController from "./focus_controller"
application.register("focus", FocusController)

import FormSubmitController from "./form_submit_controller"
application.register("form-submit", FormSubmitController)

import Forms__AddressAutocompleteController from "./forms/address_autocomplete_controller"
application.register("forms--address-autocomplete", Forms__AddressAutocompleteController)

import Forms__DisableController from "./forms/disable_controller"
application.register("forms--disable", Forms__DisableController)

import Forms__SubmitController from "./forms/submit_controller"
application.register("forms--submit", Forms__SubmitController)

import Ga__AddToCartController from "./ga/add_to_cart_controller"
application.register("ga--add-to-cart", Ga__AddToCartController)

import Ga__CheckoutController from "./ga/checkout_controller"
application.register("ga--checkout", Ga__CheckoutController)

import Ga__ProductListController from "./ga/product_list_controller"
application.register("ga--product-list", Ga__ProductListController)

import Ga__ProductShowController from "./ga/product_show_controller"
application.register("ga--product-show", Ga__ProductShowController)

import LinkAppendController from "./link_append_controller"
application.register("link-append", LinkAppendController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import OptionButtonController from "./option_button_controller"
application.register("option-button", OptionButtonController)

import PanelController from "./panel_controller"
application.register("panel", PanelController)

import ReviewsJumpController from "./reviews_jump_controller"
application.register("reviews-jump", ReviewsJumpController)

import ShowHideController from "./show_hide_controller"
application.register("show-hide", ShowHideController)

import VisibilityController from "./visibility_controller"
application.register("visibility", VisibilityController)

import SearchClickTrackingController from "./search_click_tracking_controller"
application.register("search-click-tracking", SearchClickTrackingController)
